import { Fragment } from "react";
import { createRoot } from 'react-dom/client';
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { Provider } from "react-redux";

import store from "./store";

const root = createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
      <Fragment>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Fragment>
    </Provider>
);

serviceWorker.unregister();
